import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './style.css';
import { SettingsProvider } from "./context/SettingsContext";

import { Provider } from 'react-redux';
import store from './store';

// 🌍 Define BASE_API_URL globally
const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

// Automatically pick correct base URL
window.BASE_API_URL = isLocalhost
  ? 'https://fosv2.foodship.net/api/fos/'
  : `${window.location.protocol}//${window.location.hostname}/api/fos/`;
window.BASE_URL = isLocalhost
  ? 'https://fosv2.foodship.net'
  : `${window.location.protocol}//${window.location.hostname}`;
console.log('✅ BASE_API_URL:', window.BASE_API_URL);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SettingsProvider>
     <App />
      </SettingsProvider>
 
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
